import { Injectable, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import 'rxjs/add/operator/takeUntil';
import { Router } from '@angular/router';
/*Services*/
import { DevicesService } from '@services/http/devices.service';
import { ScreenService } from '@services/screen.service';
import { MappingService } from '@services/data/mapping.service';
import { CachedDataService } from '@services/data/cached-data.service';

/*Models */

import { Device, ObservableObject, DeviceState, CaptchaItem } from '@models';

/*Config */
import { CONFIG } from './../../config';

/*Plugins */
import * as moment from 'moment';

@Injectable()
export class StateService implements OnDestroy {
  isSyncState = false;
  currentDevice: Device;
  currentObservableObject: ObservableObject;
  state: DeviceState;
  intervalUpdateAfterSendCommand = CONFIG.intervalUpdateAfterSendCommand;
  currentTryGetState = 0;
  maxTryGetState = 12;
  isStateChanged = false;
  isTryGetUpdateState = false;
  autoUpdatePosition = true;

  observableObjectSubject: ReplaySubject<ObservableObject> = new ReplaySubject<ObservableObject>(1);
  observableObjectObservable = this.observableObjectSubject.asObservable();

  currentDeviceSubject: ReplaySubject<Device> = new ReplaySubject<Device>(1);
  currentDeviceObservable = this.currentDeviceSubject.asObservable();

  stateSubject: ReplaySubject<DeviceState> = new ReplaySubject<DeviceState>(1);
  stateObservable = this.stateSubject.asObservable();

  isSyncStateSubject: Subject<boolean> = new Subject<boolean>();
  isSyncStateObservable = this.isSyncStateSubject.asObservable();

  autoUpdatePositionSubject: Subject<boolean> = new Subject<boolean>();
  autoUpdatePositionObservable = this.autoUpdatePositionSubject.asObservable();

  updateDevicePhoneSubject: Subject<any> = new Subject<boolean>();
  updateDevicePhoneObservable = this.updateDevicePhoneSubject.asObservable();

  needSendCaptchaSubject: Subject<any> = new Subject<boolean>();
  needSendCaptchaObservable = this.needSendCaptchaSubject.asObservable();

  toggleGraphStatsSubject: Subject<any> = new Subject<any>();
  toggleGraphStatsObservable = this.toggleGraphStatsSubject.asObservable();


  addCcodeEvent: EventEmitter<any> = new EventEmitter<any>();

  public sendCommandEvent = new EventEmitter<boolean>();
  private intervalTryGetState = null;
  currentDay = null;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private cachedDataService: CachedDataService,
    private devicesService: DevicesService,
    private screenService: ScreenService,
    private mappingService: MappingService,
    private router: Router,
  ) {
    this.currentDeviceObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(device => {
        this.currentDevice = device;
      });

    this.autoUpdatePositionObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(value => {

        this.autoUpdatePosition = value;

      });

    this.sendCommandEvent.subscribe(() => {

      if (this.intervalTryGetState && this.intervalTryGetState != null) {
        clearInterval(this.intervalTryGetState);
      }


      let truCount = this.maxTryGetState;
      const that = this;
      this.intervalTryGetState = setInterval(function () {
        if (truCount <= 0 || that.isStateChanged) {
          clearInterval(that.intervalTryGetState);
          that.isTryGetUpdateState = false;
          that.syncState(false);
          that.isStateChanged = false;
          return false;
        }
        truCount--;
        that.isTryGetUpdateState = true;
        that.syncState(true);
      }, this.intervalUpdateAfterSendCommand);
    });


    this.currentDeviceSubject
      .takeUntil(this.ngUnsubscribe)
      .subscribe(device => {
        if (this.intervalTryGetState && this.intervalTryGetState != null) {
          clearInterval(this.intervalTryGetState);
          this.isTryGetUpdateState = false;
          this.isStateChanged = false;
        }
      });

    this.currentDay = moment();
    // if (this.cachedDataService.getCurrentUser()) {
    //   this.currentDay;
    // }

  }

  loadState(deviceId?: string, captchaBody?: CaptchaItem) {
    this.devicesService.getState(deviceId ? deviceId : this.currentDevice.id, captchaBody)
      .subscribe(response => {
        response.coordinate
        if(response.coordinate){
          if(response.coordinate.latitude){
            response.coordinate.latitude = parseFloat(response.coordinate.latitude.toString().replace(",","."))
          }
          if(response.coordinate.longitude){
            response.coordinate.longitude = parseFloat(response.coordinate.longitude.toString().replace(",","."))
          }
        }
        if (this.isTryGetUpdateState) {
          this.syncState(false);
          let isEquals = true;
          for (const key in this.state.mainStates) {
            if (this.state.mainStates[key] !== response.mainStates[key]) {
              isEquals = false;
            }
          }
          if (!isEquals) {
            this.isStateChanged = true;

            this.stateSubject.next(response);
            /*todo*/
            this.state = response;
          }
          return false;
        }
        this.stateSubject.next(response);
        /*todo*/
        this.state = response;

        if (this.state.coordinate != null && this.state.coordinate.latitude && this.state.coordinate.longitude) {
          if (this.autoUpdatePosition) {
            if (this.screenService.currentMarker.latitude && this.screenService.currentMarker.longitude) {
              // If the marker is already displayed, check need to update
              if (
                this.screenService.currentMarker.latitude !== this.state.coordinate.latitude ||
                this.screenService.currentMarker.longitude !== this.state.coordinate.longitude) {
                this.setMarker();
              }
            } else {
              this.setMarker();
            }
          } else {
            this.screenService.currentMarker.latitude = null;
            this.screenService.currentMarker.longitude = null;
          }
        } else {
          this.screenService.removeMarker();
          this.screenService.setCenter();
        }

        this.syncState(false);

      }, error => {
        console.log(error);
        if (error.error) {
          error = error.error;
        }


        if (error.capchaId && error.capchaUri) {
          this.needSendCaptchaSubject.next(error);
          // this.errorMessage = error.message;
        } else if (error.errorMessage) {
            if(this.cachedDataService.needUpdatePassword){
              //if showing need update password
              return false;
            }
            if(error && error.errorMessage){
              alert(error.errorMessage);
            } else{
              setTimeout(() => {
                this.router.navigate(['/online']);
              }, 1000);
            }
          }
      });
  }
  setMarker() {
    this.mappingService.getAddress(this.state.coordinate.latitude, this.state.coordinate.longitude, (result) => {
      if (result && result[0] && result[0].formatted_address && result[0] && result[0].formatted_address) {
        let address = result[0].formatted_address;


        if (address.slice(address.length - 6, address.length).match(/^-{0,1}\d+$/)) {
          /*remove index from address */
          address = address.substring(0, address.length - 8);
        }

        const content = `<div style="max-width: 220px;">${this.currentObservableObject.name} <br> <b>Адрес:</b> ${address}</div>`;
        // tslint:disable-next-line:max-line-length
        this.screenService.setMarker(this.state.coordinate.latitude, this.state.coordinate.longitude, content, this.state.coordinate.precision);
        // if(this.state.coordinate.precision){
        // 	this.screenService.addCircle(this.state.coordinate.latitude, this.state.coordinate.longitude);
        // }else{
        // 	this.screenService.hideRadius()
        // }
      }
    });
    this.screenService.setCenter(this.state.coordinate.latitude, this.state.coordinate.longitude);
  }

  setCurrentDevice(device: Device) {
    this.currentDevice = device;
    this.currentDeviceSubject.next(device);
  }
  setCurrentObject(object: ObservableObject) {
    this.currentObservableObject = object;
    this.cachedDataService.setCurrentObject(JSON.stringify(object));
    this.observableObjectSubject.next(object);
  }

  getLastStateTime() {
    if (this.state) {
      const value = this.state.additionalStates.time.value;
      const currentDate = this.currentDay.format('DD MM YYYY');
      const date = moment.unix(this.state.additionalStates.time.value);
      if (currentDate === date.format('DD MM YYYY')) {
        return moment.unix(value).format('HH:mm:ss');
      } else {
        return moment.unix(value).format('HH:mm:ss DD.MM.YY');
      }
    }
    return '';
  }
  syncState(value) {
    this.isSyncState = value;
    this.isSyncStateSubject.next(value);
    if (value) {
      this.loadState();
    }
  }




  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/state.service.ts